import { InscriptionParcoursPath } from 'src/app/pages/inscriptions-parcours/inscription-parcours-path';
import { ParcoursPath } from 'src/app/pages/parcours/parcours-path';
import { StatistiquesPath } from 'src/app/pages/statistiques/statistiques-path';
import { AppPath } from '../../../app-path';
import { ArticlesPath } from '../../../pages/articles/articles-path';
import { DossiersFinancementPath } from '../../../pages/dossiers-financement/dossiers-financement-path';
import { EntitesPath } from '../../../pages/entites/entites-path';
import { EntreprisesPath } from '../../../pages/entreprises/entreprises-path';
import { EvaluationsPath } from "../../../pages/evaluations/evaluations-path";
import { FacturationPath } from '../../../pages/facturation/facturation-path';
import { FormateursPath } from '../../../pages/formateurs/formateurs-path';
import { FormationsPath } from '../../../pages/formations/formations-path';
import { InscriptionPath } from '../../../pages/inscriptions/inscription-path';
import { PersonnelsPath } from '../../../pages/personnels/personnels.path';
import { PersonnesPath } from '../../../pages/personnes/personnes-path';
import { ProfilsDroitsPath } from '../../../pages/profils-droits/profils-droits-path';
import { PublipostageModelesPath } from '../../../pages/publipostage-modeles/publipostage-modeles-path';
import { RessourcesPath } from '../../../pages/ressources/ressources.path';
import { SeancePath } from '../../../pages/seances/seance-path';
import { SessionPath } from '../../../pages/sessions/session-path';
import { UtilisateursPath } from '../../../pages/utilisateurs-new/utilisateurs-path';

export class EparcoursPath {
  static root = AppPath;
  static sessions = SessionPath;
  static formations = FormationsPath;
  static formateurs = FormateursPath;
  static inscriptions = InscriptionPath;
  static inscriptionsParcours = InscriptionParcoursPath;
  static entites = EntitesPath;
  static personnes = PersonnesPath;
  static profilsDroits = ProfilsDroitsPath;
  static utilisateurs = UtilisateursPath;
  static seances = SeancePath;
  static entreprises = EntreprisesPath;
  static personnels = PersonnelsPath;
  static articles = ArticlesPath;
  static dossiersFinancement = DossiersFinancementPath;
  static publipostageModele = PublipostageModelesPath;
  static facturation = FacturationPath;
  static evaluations = EvaluationsPath;
  static statistique = StatistiquesPath;
  static ressources = RessourcesPath;
  static parcours = ParcoursPath;
}
